{
    "AgentAdvanced_Fields_LicenceType": "Call Centre Tipo di licenza:",
    "AgentAdvanced_Fields_InternalNumber": "Numero interno:",
    "AgentAdvanced_Fields_CiscoCommonID": "Identità comune Cisco:",
    "AgentAdvanced_Fields_OverrideMonitoring": "Monitoraggio dell'override:",
    "AgentAdvanced_Fields_WebexCallingUserID": "ID utente chiamante Webex:",
    "AgentAdvanced_Fields_BroadworksUserID": "ID utente BroadWorks:",
    "AgentAdvanced_Fields_TeamsUserID": "ID utente MS Teams:",
    "AgentAdvanced_Fields_UserPrincipalName": "Nome principale dell'utente (URN):",
    "AgentAdvanced_Fields_OwningGroupID": "ID del gruppo proprietario:",
    "AgentAdvanced_Fields_OIDOnTelephoneServer": "OID sul server telefonico:",
    "AgentAdvanced_Fields_OwningDepartment": "Dipartimento proprietario (percorso completo):",
    "CallCentreLicenceTypes_None": "[Nessuno]",
    "CallCentreLicenceTypes_Basic": "Base",
    "CallCentreLicenceTypes_Standard": "Standard",
    "CallCentreLicenceTypes_Premium": "Premio",
    "NAME": "AgentAdvanced"
}